import { createMutationHook } from "@accurx/api/QueryClient";
import {
    ExternalEmailContact,
    GetContactWithMetadataResponse,
} from "@accurx/api/clinician-messaging";
import { httpClient2 } from "@accurx/shared";

import { ContactDetailsQueryKey } from "../queries/useContactDetailsQuery";
import { DirectorySearchQueryKey } from "../queries/useDirectorySearchQuery";

export const DeleteContactKey = "DeleteContact";

type DeleteContactArgs = {
    workspaceId: number;
    contactId: string;
};

export const useDeleteContact = createMutationHook<DeleteContactArgs>(
    ({ queryClient }) => ({
        mutationKey: [DeleteContactKey],
        mutationFn: async ({ contactId, workspaceId }) =>
            await httpClient2.delete({
                path: "/api/clinicianmessaging/directory/:workspaceId/contacts/:contactId",
                params: {
                    workspaceId,
                    contactId,
                },
            }),

        onSuccess: (_, { workspaceId, contactId }) => {
            queryClient.setQueriesData<ExternalEmailContact[]>(
                [DirectorySearchQueryKey],
                (currentData) => {
                    if (!currentData) {
                        return undefined;
                    }
                    return currentData
                        .map((contact) => {
                            if (contact.id === contactId) {
                                return undefined;
                            }
                            return contact;
                        })
                        .filter(isInstance);
                },
            );

            queryClient.setQueryData<GetContactWithMetadataResponse>(
                [ContactDetailsQueryKey, { workspaceId, contactId }],
                () => undefined,
            );
        },
    }),
);

const isInstance = <T>(item: T | undefined): item is T => {
    return !!item;
};
